import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteProblem from "../blocks/deleteProblem";
import {toast} from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {getAlLProblems, messageReset} from "../store/problems";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import {FormControl, InputAdornment, InputLabel, OutlinedInput, Pagination} from "@mui/material";

const PAGE_SIZE = 20

function Problems(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const regionId = params.id || false
    const toBack = () => navigate(-1)

    const [open, setOpen] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [searchCompany, setSearchCompany] = useState('')
    const [page, setPage] = useState(1)
    const [searchTimer, setSearchTimer] = useState(null)

    function fetchData(pg, sc) {
        props.getAlLProblems(pg || page, PAGE_SIZE, sc !== undefined ? sc : searchCompany, regionId || '')
    }

    useEffect(() => {
        // Original: token verify + data yuklash
        const token = localStorage.getItem('token')
        if (token !== 'undefined') {
            props.getAllVerifyResponse({"token": JSON.parse(token)})
        }
        fetchData(1, '')
    }, [])

    // Original: verify tekshiruvi
    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            setOpenItem(false); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => {
            setPage(1); fetchData(1, searchCompany)
        }, 400)
        setSearchTimer(timer)
    }, [searchCompany])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function getFullDateTime(val) {
        let newDate = new Date(val)
        let date = newDate.getDate(); date = date < 10 ? "0" + date : date
        let month = newDate.getMonth() + 1; month = month < 10 ? "0" + month : month
        let year = newDate.getFullYear()
        let hours = newDate.getHours(); let minutes = newDate.getMinutes(); let seconds = newDate.getSeconds()
        return date + "." + month + "." + year + "\t" + hours + ":" + minutes + ":" + seconds
    }

    function toAdd() { navigate('/add-problem/') }
    function toView(item) { navigate('/view-problem/' + item.id) }
    function toEdit(data) { navigate('/edit-problem/' + data.id) }
    function toDelete(item) { setOpenItem(item); setOpen(true) }

    const problems = props.problems || []

    return <div>
        <div className={'page worker-page problems'}>
            {open ? <DeleteProblem setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                        {t('back')}
                    </Button>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{t('problems')}</h2>
                        {!is_main && (
                            <Button variant="contained" endIcon={<AddIcon/>} onClick={toAdd}>
                                {t('add_problem')}
                            </Button>
                        )}
                    </div>

                    {is_main && !regionId && (
                        <div style={{marginBottom: '16px'}}>
                            <FormControl variant="outlined" style={{minWidth: 300}}>
                                <InputLabel htmlFor="search-prob">{t('search_company')}</InputLabel>
                                <OutlinedInput
                                    id="search-prob" value={searchCompany}
                                    onChange={(e) => setSearchCompany(e.target.value)}
                                    endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                    label={t('search_company')}/>
                            </FormControl>
                        </div>
                    )}

                    {problems.length ? (
                        <table className="table table-hover table-responsive">
                            <thead>
                            <tr>
                                <th scope="col">#</th>
                                {is_main && <th scope="col">{t('title_company')}</th>}
                                <th scope="col">{t('problem_title')}</th>
                                <th scope="col">{t('problem_date')}</th>
                                <th scope="col"/>
                            </tr>
                            </thead>
                            <tbody>
                            {problems.map((item, index) => (
                                <tr key={item.id}>
                                    <th scope="row">{(page - 1) * PAGE_SIZE + index + 1}</th>
                                    {is_main && <td>{item.user?.user_name ? item.user.user_name : 'ADMIN'}</td>}
                                    <td>{item.title}</td>
                                    <td>{getFullDateTime(item.modified)}</td>
                                    {!item.user.is_main ? (
                                        <td>
                                            {is_main
                                                ? <Button variant="contained" color="primary"
                                                          endIcon={<VisibilityIcon/>}
                                                          onClick={() => toView(item)}/>
                                                : <Button variant="contained" color="info"
                                                          endIcon={<EditIcon/>}
                                                          onClick={() => toEdit(item)}/>
                                            }
                                            <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                    onClick={() => toDelete(item)}/>
                                        </td>
                                    ) : (
                                        <td style={{minHeight: "42px"}}>
                                            {is_main && item.user.is_main && (
                                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                        onClick={() => toDelete(item)}/>
                                            )}
                                        </td>
                                    )}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className={'no-infos'}>{t('no_info')}</div>
                    )}

                    {props.total_pages > 1 && (
                        <div style={{display: 'flex', justifyContent: 'center', padding: '20px 0'}}>
                            <Pagination count={props.total_pages} page={page}
                                        onChange={handlePageChange} color="primary" shape="rounded"/>
                        </div>
                    )}
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.problems, {getAlLProblems, getAllVerifyResponse, messageReset})(Problems)